import React from "react";
import { Layers, Store, MapPin, Building2, Hotel, HeartPulse } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { Reveal, SectionHeading } from "./Reveal";

const ICONS = [Layers, Store, MapPin, Building2, Hotel, HeartPulse];

export const Investment = () => {
  const { t } = useLang();

  return (
    <section id="investment" className="relative py-24 md:py-32 bg-[#0D0D0D] border-y border-[#1c1c1c]" data-testid="investment-section">
      <div className="px-6 md:px-12 lg:px-20">
        <SectionHeading overline={t.investment.overline} title={t.investment.title} text={t.investment.text} center />

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.investment.cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={0.06 * i}>
                <div className="group h-full bg-[#0A0A0A] border border-[#2E2E2E] p-8 hover:border-[#D4AF37]/50 transition-colors duration-500" data-testid={`investment-card-${i}`}>
                  <div className="flex items-center justify-between">
                    <Icon size={26} strokeWidth={1} className="text-[#D4AF37]" />
                    <span className="font-serif text-3xl text-[#FFFFF0]/15 group-hover:text-[#D4AF37]/30 transition-colors">
                      0{i + 1}
                    </span>
                  </div>
                  <h3 className="mt-6 font-serif text-2xl font-light text-[#FFFFF0]">{card.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#FFFFF0]/60 font-light">{card.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
